import axios from 'axios'
import Cookies from 'js-cookie'
// import config from '../../config/config.base'

let instance = axios.create({
  headers: {
    'content-type': 'application/json',
    'token': Cookies.get('rtac_tk')
  }
  // headers: {'token': Cookies.get('rtac_tk')}
})

instance.defaults.baseURL = process.env.BASE_API

// instance.defaults.withCredentials = true

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // config.headers.channelToken = Cookies.get('channelToken')
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use((response) => {
  // 对响应数据做点什么
  // if (response.status === '200') {
  //   if (response.data.code === '1001') {
  //   }
  // }
  return response.data
}, (error) => {
  // 对响应错误做点什么
  console.log(error && error.response && error.response.status)
  console.log(`--- ${error.response.status} res error response ---`)
  console.log(error.response)
  if (error && error.response && error.response.status === 403) {
    window.location = `https://m.easthome.com/mindex/member/tologin`
  }
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/util/request.js